import articleHtml, { otherHtml } from "./article_template";
import accordian from "src/components/accordian/accordian";
import { articlesExtend, getDynamicContent, findsite, getFromContent, wrap } from "src/scripts/mixin";


export default (article) => {


document.body.classList.add("article");
    
    if(article.title.indexOf(':')>0) {
        let titleSplit = article.title.split(":");
        article.year = titleSplit[0];
        titleSplit.shift();
        article.title = titleSplit.join(":");
    }
    
    // console.log(article);
    
    article = articlesExtend(article);
    
    article.contentParsed = fixArticle(article.contentParsed);
    
    
    // let imagesobj = [];
    if (article.metaParsed) {
        if (article.metaParsed.imageContentId) {

            // console.log("hasImage",item.metaParsed);

            article.mainImage = {
                src: "none",
                dataid: article.metaParsed.imageContentId,
                desc: article.metaParsed.imageDescription
            }

        }
        else {
            article.mainImage = false
        }
    }
    
    // console.log(article)
    if(window.site !== "annet") {
        return articleHtml(article);
    } else {
        return otherHtml(article);
    }
        
    
}



const fixArticle = (html) => {
    
    
    const parser = new DOMParser();
    const dom = parser.parseFromString(html, "text/html");
    
    // Add image wrapper
    dom.querySelectorAll("img").forEach(img => {
       
        
        wrap(img, "div", wrapper => {
           
           wrapper.classList.add("article__imagecontainer") 
           wrapper.dataset.changes="true";
           return wrapper;
            
        });
        
        
        img.removeAttribute("style");
        
        const alt = img.getAttribute("alt");
        if(alt){
            let altspan = document.createElement("span");
            altspan.innerHTML = alt;
            altspan.classList.add("article__imagedesc");
            img.after(altspan);
        }
        
    });
    
    // fix buttons
    dom.querySelectorAll(".simple-button-plugin").forEach(button => {
       
       const bgcolor = button.style.backgroundColor;
       let btntype = "primary";
       if(bgcolor === "white") {
           btntype = "secondary";
       }
       
       button.removeAttribute("style");
       button.removeAttribute("draggable");
        
       button.classList.add("btn");
       if(btntype === "primary"){
           button.classList.add("btn-primary");
           button.classList.add("article__button__primary");
       }
       else {
           button.classList.add("btn-secondary");
           button.classList.add("article__button__secondary");
       }
        
    });
    
    // correct accordian 
    accordian(dom);
    
    
    return dom.body.innerHTML;
}

const changeImages = () => {
    
}